import { memo, useState } from "react";
import { TIServiceForm } from "../../iServiceSchema";
import { IServiceType } from "../IServiceType";
import { PlugNotas } from "./PlugNotas";
import { useTranslation } from "react-i18next";
import { IIServiceType } from "../../../../../../../models/i-service-type";
import { useFormContext } from "@4uhub/lib4uhub";
import { useIServiceType } from "../useIServiceType";
import { useParams } from "react-router-dom";
import { IPlugNotas } from "../models";

interface IPlugNotasWrapperProps {
  iServiceTypes: IIServiceType[];
}

const PLUG_NOTAS_IMAGE = {
  src: "/iServices/plug-notas.svg",
  alt: "PlugNotas",
  variant: "rounded" as const,
  sx: {
    width: 56,
    borderRadius: 1.5,
    bgcolor: "transparent",
  },
};

const translationPath = "page.4uBus.register.iService.";

export const PlugNotasWrapper = memo(
  ({ iServiceTypes }: IPlugNotasWrapperProps) => {
    const { id } = useParams();

    const { t } = useTranslation();

    const { setValue, getValues } = useFormContext<TIServiceForm>();

    const { jsonParser, plugNotasValues } = useIServiceType();

    const plugNotasType = iServiceTypes.find(
      (item) => item.code === plugNotasValues.code,
    );

    const [isSelected, setIsSelected] = useState(() => {
      const plugNotas = getValues("plugNotas");
      return !!plugNotas;
    });

    const saveConfigsJson = (v: TIServiceForm) => {
      const values = v.plugNotas;
      if (!values) return;

      return values;
    };

    const handleConfirm = () => {
      if (plugNotasType) {
        setValue("iServiceType", plugNotasType);
      }
      setIsSelected(true);
    };

    const handleClearConfigs = () => {
      setValue("configs", null);
      setValue("companyDigitalCertificate", null);
      setValue("iServiceType", null);
      setValue("plugNotas", plugNotasValues.defaultValues);
      setIsSelected(false);
    };

    const handleOpen = () => {
      setValue("plugNotas", plugNotasValues.defaultValues);
    };

    const handleCloseSelected = () => {
      const configs = getValues("configs");
      const plugNotasValue = jsonParser<IPlugNotas>(configs);
      setValue("plugNotas", plugNotasValue);
    };

    const isEditingScreen = !!id;

    if (!plugNotasType) {
      return null;
    }

    return (
      <IServiceType
        img={PLUG_NOTAS_IMAGE}
        renderComponent={({ namePrefix }) => (
          <PlugNotas namePrefix={namePrefix} />
        )}
        isSelected={isSelected}
        isEditingScreen={isEditingScreen}
        getFormattedData={saveConfigsJson}
        onConfirm={handleConfirm}
        onClearConfigs={handleClearConfigs}
        onOpen={handleOpen}
        onCloseSelected={handleCloseSelected}
        iServiceTypeName="plugNotas"
        serviceName={t(translationPath + "plug_notas")}
      />
    );
  },
);
